<template>
  <div>
    <i-modal
      :value="isShow"
      @on-cancel="cancel"
      width="600px"
      class-name="vertical-center-modal"
      :styles="{ minWidth: '500px' }"
      footer-hide
    >
      <div slot="header" class="title">
        <h2>新增</h2>
      </div>
      <div class="content">
        <div>
          <i-row class="a-row" align="middle">
            <i-col span="4" offset="1">
              <span class="text">模板名：</span>
            </i-col>
            <i-col :span="18">
              <i-input v-model="name" class="col-input" type="text"></i-input>
            </i-col>
          </i-row>
          <i-row class="a-row" align="middle">
            <i-col span="4" offset="1">
              <span class="text">简介：</span>
            </i-col>
            <i-col :span="18">
              <i-input v-model="desc" class="col-input" type="text"></i-input>
            </i-col>
          </i-row>
          <i-row class="a-row" align="middle">
            <i-col span="4" offset="1">
              <span class="text">内容：</span>
            </i-col>
            <i-col :span="18">
              <i-input v-model="content" class="col-input" type="textarea" :rows="4"></i-input>
            </i-col>
          </i-row>
        </div>
        <i-row class="a-row" align="middle">
          <i-col offset="1" span="22" align="center">
            <i-button type="success" class="article-button" @click="addTemplate">
              提交
            </i-button>
          </i-col>
        </i-row>
      </div>
    </i-modal>
  </div>
</template>

<script>
import { baseConfigMixin } from "../mixin"

export default {
  name: "editTemplateModal",
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    editData: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  mixins: [baseConfigMixin],
  data() {
    return {
      name: "",
      desc: "",
      content: "",
      id: "",
    }
  },
  methods: {
    init() {
      this.id = ""
      this.name = ""
      this.desc = ""
      this.content = ""
    },
    cancel() {
      this.init()
      this.$emit("cancel")
    },
    async addTemplate() {
      const self = this
      if (!this.name) {
        this.$Message.error("请填写模板名！")
        return
      }
      if (!this.content) {
        this.$Message.error("请填写模板内容！")
        return
      }
      self.showLoading = true
      let xData = {
        tid: this.id,
        name: this.name,
        desc: this.desc,
        content: this.content,
      }
      try {
        const res = await self.axios({
          method: "post",
          url: this.cmsUrl + "api/content/template/edit",
          data: xData,
        })
        if (!res) {
          return
        }
        if (res.data.code === 0) {
          self.showLoading = false
          self.$Message.success("添加成功！")
          self.$emit("success")
        } else {
          self.showLoading = false
          self.$Message.error("操作失败，错误原因：" + res.data.error_message)
          console.log(res)
        }
      } catch (err) {
        self.showLoading = false
        self.$Message.error("操作失败，错误原因：" + err)
        console.log(err)
      }
    },
  },
  watch: {
    isShow() {
      if (!this.isShow) {
        this.init()
      } else {
        this.name = this.editData.name
        this.desc = this.editData.desc
        this.content = this.editData.content
        this.id = this.editData.id
      }
    },
  },
}
</script>
<style scoped>
.title {
  text-align: center;
}
.a-row {
  margin: 20px 0;
}
</style>
<style lang="scss">
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-modal {
    top: 0;
  }
}
</style>
